<script setup>
import { ref } from 'vue';
import suscripciones from '../../../../../api/cifra/suscripciones';
import BotonGuardar from '../../../../../components/inputs/BotonGuardar.vue';

// Props
defineProps({
  urlPlantillaAlumnos: {
    type: String,
    required: true,
  },
});

// Emits
const emit = defineEmits(['cargada']);

// Template refs
const input = ref();

// Reactive data
const buscando = ref(false);

// Methods
const seleccionarFichero = () => {
  input.value.click();
};

const cargarExcel = async (event) => {
  const file = event.target.files[0];
  if (file == null) {
    return;
  }

  buscando.value = true;

  try {
    const result = await suscripciones.buscarAlumnosExcel(file);
    emit('cargada', result.data);
    buscando.value = false;
  } catch {
    buscando.value = false;
  }
};
</script>

<template>
  <!-- Split button -->
  <div class="btn-group">
    <BotonGuardar
      type="button"
      action="buscar"
      variant="success"
      :submitting="buscando"
      @click="seleccionarFichero"
    >
      <i class="fa fa-file-excel"></i>
      {{ $I18n.t('cargar_excel') }}
    </BotonGuardar>
    <button
      type="button"
      class="btn btn-success dropdown-toggle"
      data-toggle="dropdown"
    >
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu">
      <li>
        <a :href="urlPlantillaAlumnos">
          <i class="fa fa-download"></i>
          {{ $I18n.t('plantilla') }}
        </a>
      </li>
    </ul>
    <input
      ref="input"
      type="file"
      class="hide"
      @change="cargarExcel"
    />
  </div>
</template>
